import { render, staticRenderFns } from "./RegionsBlock.vue?vue&type=template&id=6c2cc43c&scoped=true"
import script from "./RegionsBlock.vue?vue&type=script&lang=ts"
export * from "./RegionsBlock.vue?vue&type=script&lang=ts"
import style0 from "./RegionsBlock.vue?vue&type=style&index=0&id=6c2cc43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2cc43c",
  null
  
)

export default component.exports